module.exports = __webpack_public_path__ + "static/media/home-mobile.fd34dbe5.png";